import * as React from 'react';
import { FixMeLater } from '../../../utils';

export interface ModularPriceFractionProps {
    /**
     * The price's fraction digits.
     */
    children?: string;
}

export const ModularPriceFraction: React.ForwardRefExoticComponent<
    ModularPriceFractionProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function ModularPriceFraction(
    props: ModularPriceFractionProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, ...other } = props;
    return (
        <span ref={ref} data-fraction={true} {...other}>
            {children}
        </span>
    );
});
